


































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import StoreSuketMcuGol2 from "@/store/modules/SuketMcuGol2";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storeDokter } from "@/store/modules/dokter";
import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf
  }
})
export default class SuketMcuGol2TabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  // MCU Gol II DPT dapat diterbitkan di poli MCU/Penyakit Dalam mana pun →
  // izinkan di seluruh unit. Kunci read-only tetap dari edit-window halaman.
  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.McuGol2);
  suketStore = StoreSuketMcuGol2;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;

  identitas: any = {
    nama_kecil: null,
    nip: null,
    jabatan: null,
    pekerjaan: "Pegawai Negeri Sipil",
    golongan: null,
    alamat: null
  };
  permintaan: any = {
    dari: null,
    nomor: null,
    tanggal: null
  };
  kesimpulan: any = {
    opsi: null,
    jenis_pekerjaan: null,
    catatan: null
  };

  saving = false;
  loadedRatio = 0;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  golonganOptions = [
    "II/a",
    "II/b",
    "II/c",
    "II/d"
  ];
  kesimpulanOptions = [
    {
      value: "a",
      label: "Memenuhi syarat untuk semua jenis pekerjaan pada umumnya."
    },
    {
      value: "b",
      label: "Memenuhi syarat untuk jenis pekerjaan tertentu."
    },
    {
      value: "c",
      label:
        "Dapat diterima dengan bersyarat untuk (a) atau (b) tersebut di atas."
    },
    {
      value: "d",
      label:
        "Untuk sementara belum memenuhi syarat kesehatan dan memerlukan pengobatan/perawatan dan ujian kesehatan perlu diulang setelah selesai pengobatan/perawatan atau di tolak sementara."
    },
    {
      value: "e",
      label:
        "Tidak memenuhi syarat untuk menjalankan tugas sebagai Pegawai Negeri Sipil."
    }
  ];

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get catatanRules() {
    if (this.kesimpulan.opsi && this.kesimpulan.opsi !== "a") {
      return [
        v => (!!v && v.length >= 30) || "Wajib diisi minimal 30 karakter"
      ];
    }
    return [];
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.McuGol2, this.dataSuket.id)
      : null;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        identitas: this.identitas,
        permintaan: this.permintaan,
        kesimpulan: this.kesimpulan
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  mounted() {
    this.hydrate(this.dataSuket);
  }

  hydrate(d: any) {
    this.register_id = d?.register_id || this.register;
    this.pasien_rm = d?.pasien_rm || this.pasien.rm;
    this.unit_id = d?.unit_id || this.user.unit_id;
    this.nama = this.pasien.nama;
    this.surat_date = d?.surat_date || new Date();
    this.signee_user_id = d?.signee_user_id || this.user.id;
    this.creator_user_id = d?.creator_user_id || this.user.id;

    const c = d?.content;
    if (c) {
      this.identitas = { ...this.identitas, ...(c.identitas || {}) };
      this.permintaan = { ...this.permintaan, ...(c.permintaan || {}) };
      this.kesimpulan = { ...this.kesimpulan, ...(c.kesimpulan || {}) };
    } else if (!this.identitas.alamat) {
      // Pre-fill alamat dari KTP pasien bila belum diisi.
      this.identitas.alamat = this.pasien.alamat || null;
    }
  }

  @Watch("dataSuket")
  changeDataSuket(val: any) {
    this.hydrate(val);
  }

  save() {
    if (this.saving) return;

    if (!this.kesimpulan.opsi) {
      appModule.sendErrorAlert("Opsi kesimpulan pengujian wajib dipilih");
      return;
    }
    if (
      this.kesimpulan.opsi !== "a" &&
      (this.kesimpulan.catatan || "").length < 30
    ) {
      appModule.sendErrorAlert(
        "Catatan/justifikasi klinis wajib diisi minimal 30 karakter bila kesimpulan bukan opsi (a)"
      );
      return;
    }
    if (
      this.kesimpulan.opsi === "b" &&
      !this.kesimpulan.jenis_pekerjaan
    ) {
      appModule.sendErrorAlert(
        "Jenis pekerjaan tertentu wajib diisi bila kesimpulan opsi (b)"
      );
      return;
    }

    this.saving = true;
    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        if (this.canSign) {
          this.showSignatureModal();
        }
        appModule.NoticeDelay("Berhasil Simpan");
        this.close();
        StoreSuketMcuGol2.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }
}
